require("./feature-panel-w-carousel.scss");
require("./owl.carousel.min.js");


(function () {
    $(document).ready(function () {

        $(".feature-panel-carousel__carousel_wrapper").each(function (i, carousel) {

            var carouselItemCount = $(`#${carousel.id}`).children('.card').length;
            var minCardsReqForNav = 4;
            var isLoopEnabled = false;
            var isRewindEnabled = false;

            var navClasses = `.${carousel.id}-feature-nav`;

            if (carouselItemCount <= minCardsReqForNav) {
                navClasses = "";
                isLoopEnabled = false;
                isRewindEnabled = false;
            }

            $(`#${carousel.id}`).owlCarousel({
                loop: isLoopEnabled,
                margin: 15,
                rewind: isRewindEnabled,
                navText: [],
                navContainer: navClasses,
                responsiveClass: true,
                lazyLoad: true,
                navSpeed: 125,
                dots: false,
                responsive: {
                    0: {
                        items: 2,
                        nav: true,
                        slideBy: 2
                    },
                    768: {
                        items: 3,
                        nav: true,
                        slideBy: 3
                    },
                    992: {
                        items: minCardsReqForNav,
                        nav: true,
                        smartSpeed: 600,
                        slideBy: 4
                    }
                }
            });

            $('.feature-panel-carousel__carousel_wrapper .owl-theme .owl-dot span').addClass('bg-primary');
            $('.owl-prev').attr('data-webm-clickvalue', 'back');
            $('.owl-next').attr('data-webm-clickvalue', 'next');
        });
    });
})();